import axios from "axios";
import { apiconfig } from "src/config";
import { toast } from "react-hot-toast";

const reSourceService = axios.create({
  baseURL: apiconfig.baseURL,
  headers: {
    "content-type": "application/json",
    apiKey: apiconfig.apiKey,
    clientId: apiconfig.clientId,
  },
  //create connect to URL api,apikey key connect to server,clientid :id client connect to server api
});
reSourceService.interceptors.request.use(async (config) => {
  const authorizationData = JSON.parse(
    localStorage.getItem("authorizationData")
  );
  if (authorizationData) {
    const token = authorizationData.Token;
    config.headers.common["Authorization"] = "Bearer " + token;
  }
  return config;
});
reSourceService.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    //console.log('Error', error.message);
    if (error?.response?.status == 401) {
      toast.error("Xác thực hết hạn. Đăng nhập lại sau 6s", { duration: 6000 });
      localStorage.removeItem("authorizationData");
      setTimeout(() => {
        window.location.href = "/login";
      }, 6000);
    } 
    throw error;
  }
);
export default reSourceService;
